import React from 'react';
import { Image, Text, View, StyleSheet } from '@react-pdf/renderer';
import { colors, typography, spacing } from './styles/theme';
import { SectionTitle, ChartContainer } from './components';

const styles = StyleSheet.create({
  container: {
    paddingBottom: spacing.lg,
  },
  descriptionText: {
    ...typography.body,
    marginTop: spacing.md,
    marginBottom: spacing.xl,
    paddingHorizontal: spacing.sm,
  },
  timelineSection: {
    marginTop: spacing.lg,
  },
  highlightBox: {
    backgroundColor: colors.background.highlight,
    borderLeftWidth: 3,
    borderLeftColor: colors.primary,
    borderLeftStyle: 'solid',
    padding: spacing.md,
    marginTop: spacing.md,
    marginBottom: spacing.md,
  },
  highlightText: {
    ...typography.body,
    color: colors.text.primary,
  },
});

const Page3 = ({
  c2 = null,
  firstCountry = '',
  firstCity = '',
  secondCountries = [],
  c3 = null,
  maxHour = '',
  maxConcurrence = 0,
}) => {
  // Build country description
  let countryDescription = '';
  if (firstCountry) {
    countryDescription = `La mayoría de tu audiencia se conectó desde ${firstCountry}`;
    if (firstCity) {
      countryDescription += `, encontrando un gran número de conexiones desde la ciudad de ${firstCity}`;
    }
    countryDescription += '.';

    if (secondCountries.length > 0) {
      countryDescription += ` También hubo participación significativa desde ${secondCountries.join(' y ')}.`;
    }
  }

  // Build timeline description (typo fixed: "trnamisión" -> "transmisión")
  const timelineDescription = maxHour
    ? `El nivel máximo de espectadores conectados se registró a las ${maxHour} horas, alcanzando ${maxConcurrence.toLocaleString()} personas conectadas simultáneamente.`
    : '';

  return (
    <View style={styles.container} break>
      {/* Countries Section */}
      <SectionTitle title="Análisis Geográfico" />

      <ChartContainer
        title="Espectadores Conectados por País"
        chartImage={c2}
        chartHeight={180}
        description="Esta gráfica representa la cantidad de espectadores únicos que ingresaron a tu transmisión, agrupados por país de origen."
      />

      {countryDescription && (
        <Text style={styles.descriptionText}>{countryDescription}</Text>
      )}

      {/* Timeline Section */}
      <View style={styles.timelineSection} break>
        <SectionTitle
          title="Análisis Temporal"
          subtitle="Evolución de la audiencia durante la transmisión"
        />

        <ChartContainer
          title="Espectadores por Hora"
          chartImage={c3}
          chartHeight={180}
          description="Esta gráfica representa la cantidad de espectadores conectados durante la transmisión de tu evento, mostrando la evolución temporal de la audiencia."
        />

        {timelineDescription && (
          <View style={styles.highlightBox}>
            <Text style={styles.highlightText}>{timelineDescription}</Text>
          </View>
        )}
      </View>
    </View>
  );
};

export default Page3;
